import axios from "axios";
import {useToast} from "vue-toastification";
import router from "../../router";

export default {
	namespaced: true,
	state: {
		products: {
			products: {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
			best_seller: {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
			top_liked: {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
			new_arrival: {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
			search: {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
			featured: {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
			home_page_products : {data: [], total: 0, per_page: 0, current_page: 0, last_page: 0},
		},
		featuredProducts: [],
		lastPage: null,
		selectedProduct: null,
		brands: [],
		total_products: 0,
		status: {
			products: {
				loading: true,
				error: "",
			},
			best_seller: {
				loading: true,
				error: "",
			},
			top_liked: {
				loading: true,
				error: "",
			},
			new_arrival: {
				loading: true,
				error: "",
			},
			featured: {
				loading: true,
				error: "",
			},
			selectedProduct: {
				loading: true,
				error: "",
			},
			updateProducts: {
				loading: false,
				error: "",
			},
			brands: {
				loading: false,
				error: "",
			},
			home_page_products: {
				loading: false,
				error: "",
			}
		},
	},
	getters: {
		getProducts: (state) => state.products,
		getStatus: (state) => state.status,
		getProductById: (state) => (id) =>
			state.products.find((product) => product.id == id),
		selectedProduct: (state) => state.selectedProduct,
		getBrands: (state) => state.brands,
		getLastPage: (state) => state.lastPage,
		getFeaturedProducts: (state) => state.featuredProducts,
		getTotalProducts: (state) => state.total_products,
	},
	actions: {
		//top liked Products
		async fetchProducts({commit}) {
			commit("setLoading", {dataName: "products", status: true});
			let token = localStorage.getItem("token");
			let {lat, lng} = JSON.parse(localStorage.getItem("location"));
			try {
				let {data} = await axios.post(
					process.env.VUE_APP_API_URL + "/api/frontend/near-products",
					{latitude: lat.toString(), longitude: lng.toString()},
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				);
				console.log("products", data.payload);
				commit("setProducts", data.payload);
				commit("setLoading", {dataName: "products", status: false});
			} catch (error) {
				// useToast().error('Error While Fetching Products', {timeout : 3000})
				commit("setProducts", []);
				commit("setLoading", {dataName: "products", status: false});
			}
		},
		async getProductById({commit}, id) {
			commit("setLoading", {dataName: "selectedProduct", status: true});
			let token = localStorage.getItem("token");
			try {
				let {data} = await axios.get(
					process.env.VUE_APP_API_URL + "/api/frontend/products/" + id,
					{
						headers: {
							Authorization: `Bearer ${token}`,
						},
					}
				);
				commit("setSelectedProduct", data.payload);
				console.log(data.payload);
				commit("setLoading", {dataName: "selectedProduct", status: false});
			} catch (error) {
				console.log(error);
			}
		},
		async getProductByCategoryId(
			{commit},
			{
				id,
				priceFrom,
				priceTo,
				brandId,
				pageNo = 1,
				rating,
				sortBy = "featured",
				search,
			}
		) {
			if (pageNo > 1) {
				commit("setLoading", {dataName: "updateProducts", status: true});
			} else {
				commit("setLoading", {dataName: "products", status: true});
			}

			let token = localStorage.getItem("token");
			let LocalLatLng = JSON.parse(localStorage.getItem("location"));
			let url =
				process.env.VUE_APP_API_URL + "/api/warehouses/get-range?category_id=" + id;
			// latitude=11&longitude=11
			if (priceFrom && priceTo) {
				url = url + `&priceFrom=${priceFrom}&priceTo=${priceTo}`;
			}
			if (brandId) {
				url = url + `&brand_id=${brandId}`;
			}
			if (rating) {
				url = url + `&rating=${rating}`;
			}
			if (sortBy) {
				url = url + `&sortBy=${sortBy}`;
			}
			if (search) {
				url = url + `&searchBy=${search}`;
			}
			if (LocalLatLng) {
				url = url + `&latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
			}
			if (pageNo) {
				url = url + `&page=${pageNo}`;
			}
			console.log("URL With Params", url);
			try {
				let {data} = await axios.post(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				console.log("Products By CategoryID : " + id, data.payload);
				if (sortBy == "featured") {
					data.payload.data.unshift(...data.payload.featured); //prepend featured products in products array i.e data.payload.data
				}
				if (pageNo > 1) {
					commit("updateProducts", {type: "products", payload: data.payload});
				} else {
					commit("setProducts", {type: "products", payload: data.payload});
				}
				commit("setLoading", {dataName: "products", status: false});
				commit("setLoading", {dataName: "updateProducts", status: false});
			} catch (error) {
				commit("setLoading", {dataName: "products", status: false});
				commit("setLoading", {dataName: "updateProducts", status: false});
				useToast().error("Error While Fetching Products Using Category ID : " + id, {
					timeout: 3000,
				});
				useToast().error(error.response.data.message, {timeout: 3000});
			}
		},
		async getProductByType(
			{commit},
			{
				type,
				priceFrom,
				priceTo,
				brandId,
				pageNo = 1,
				rating,
				sortBy = "featured",
				search,
			}
		) {
			if (pageNo > 1) {
				commit("setLoading", {dataName: "updateProducts", status: true});
			} else {
				commit("setLoading", {dataName: "products", status: true});
			}
			let token = localStorage.getItem("token");
			let LocalLatLng = JSON.parse(localStorage.getItem("location"));
			let url =
				process.env.VUE_APP_API_URL + "/api/products/get-range?sortBy=" + sortBy;
			// latitude=11&longitude=11
			if (priceFrom && priceTo) {
				url = url + `&priceFrom=${priceFrom}&priceTo=${priceTo}`;
			}
			if (brandId) {
				url = url + `&brand_id=${brandId}`;
			}
			if (rating) {
				url = url + `&rating=${rating}`;
			}
			if (search) {
				url = url + `&searchBy=${search}`;
			}
			if (LocalLatLng) {
				url = url + `&latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
			}
			if (pageNo) {
				url = url + `&page=${pageNo}`;
			}

			console.log("URL With Params", url);
			try {
				let {data} = await axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				console.log("Products By Type : " + sortBy, data.payload);
				if (pageNo > 1) {
					commit("updateProducts", {type: "products", payload: data.payload});
				} else {
					commit("setProducts", {type: "products", payload: data.payload});
				}
				commit("setLoading", {dataName: "products", status: false});
				commit("setLoading", {dataName: "updateProducts", status: false});
			} catch (error) {
				commit("setLoading", {dataName: "products", status: false});
				useToast().error("Error While Fetching Products By Type : " + type, {
					timeout: 3000,
				});
				router.push({name: "Home"});
			}
		},

		async getBestSellerProducts({commit}) {
			commit("setLoading", {dataName: "products", status: true});
			let url = process.env.VUE_APP_API_URL + "/api/product/best-sellers";
			let token = localStorage.getItem("token");
			let LocalLatLng = JSON.parse(localStorage.getItem("location"));
			if (LocalLatLng) {
				url = url + `?latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
			}
			try {
				let {data} = await axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				console.log("Best Seller Products : ", data.payload);
				commit("setProducts", {type: "best_seller", payload: data.payload});
				commit("setLoading", {dataName: "best_seller", status: false});
			} catch (error) {
				commit("setLoading", {dataName: "best_seller", status: false});
				commit("setProducts", []);
				// useToast().error('Error While Fetching Best Seller Products', {timeout : 3000})
			}
		},

		async getNewArrivals({commit}) {
			commit("setLoading", {dataName: "products", status: true});
			let url = process.env.VUE_APP_API_URL + "/api/product/new-arrivals";
			let token = localStorage.getItem("token");
			let LocalLatLng = JSON.parse(localStorage.getItem("location"));
			if (LocalLatLng) {
				url = url + `?latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
			}
			try {
				let {data} = await axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				console.log("New Arrivals Products : ", data.payload);
				commit("setProducts", {type: "new_arrivals", payload: data.payload});

				commit("setLoading", {dataName: "new_arrival", status: false});
			} catch (error) {
				commit("setLoading", {dataName: "new_arrival", status: false});
				commit("setProducts", []);
				// useToast().error('Error While Fetching New Arrivals Products Products', {timeout : 3000})
			}
		},

		async getTopLiked({commit}) {
			commit("setLoading", {dataName: "products", status: true});
			let url = process.env.VUE_APP_API_URL + "/api/product/top-liked";
			let LocalLatLng = JSON.parse(localStorage.getItem("location"));
			if (LocalLatLng) {
				url = url + `?latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
			}
			let token = localStorage.getItem("token");
			try {
				let {data} = await axios.get(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				console.log("Top Liked Products : ", data.payload);
				commit("setProducts", {type: "top_liked", payload: data.payload});
				commit("setLoading", {dataName: "top_liked", status: false});
			} catch (error) {
				commit("setLoading", {dataName: "top_liked", status: false});
				commit("setProducts", []);
			}
		},
		async getFeaturedProducts({commit}) {
			//this is temp. in future this maybe changed.
			commit("setLoading", {dataName: "featured", status: true});
			let token = localStorage.getItem("token");
			let LocalLatLng = JSON.parse(localStorage.getItem("location"));
			let url =
				process.env.VUE_APP_API_URL + "/api/warehouses/get-range?sortBy=featured";
			if (LocalLatLng) {
				url = url + `&latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
			}
			try {
				let {data} = await axios.post(url, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				console.log("Featured Products : ", data.payload);
				data.payload.data = data.payload.featured // replacing data with featured
				commit("setProducts", {type: "featured", payload: data.payload});
				commit("setLoading", {dataName: "featured", status: false});
			} catch (error) {
				commit("setLoading", {dataName: "featured", status: false});
				commit("setProducts", []);
				// useToast().error('Error While Fetching New Arrivals Products Products', {timeout : 3000})
			}
		},

		async getHomePageProducts({commit}) {
			commit("setLoading", {dataName: "home_page_products", status: true});
			let url = process.env.VUE_APP_API_URL + "/api/get-home-page-products"
			try {
				let {data}  = await axios.post(url)
				console.log("Home Page Products", data.payload)
				commit("setHomePageProducts", data.payload)
				commit("setLoading", {dataName: "home_page_products", status: false});
			} catch (error) {
				console.log(error)
				commit("setLoading", {dataName: "home_page_products", status: false});
			}
		},
		// async getRecentlyViewsProducts({commit}) { //using this function in recently view component
		// 	commit("setLoading", {dataName: "products", status: true});
		// 	let token = localStorage.getItem("token");
		// 	let LocalLatLng = JSON.parse(localStorage.getItem("location"));
		// 	let url = process.env.VUE_APP_API_URL + "/api/frontend/recently-views";
		// 	if (LocalLatLng) {
		// 		url = url + `?latitude=${LocalLatLng.lat}&longitude=${LocalLatLng.lng}`;
		// 	}
		// 	try {
		// 		let {data} = await axios.get(url, {
		// 			headers: {
		// 				Authorization: `Bearer ${token}`,
		// 			},
		// 		});
		// 		console.log("Recently Views Products : ", data.payload);
		// 		commit("setProducts", {type: "products", data: data.payload});
		// 		commit("setLoading", {dataName: "products", status: false});
		// 	} catch (error) {
		// 		commit("setLoading", {dataName: "products", status: false});
		// 		commit("setProducts", []);
		// 		// useToast().error('Error While Fetching New Arrivals Products Products', {timeout : 3000})
		// 	}
		// },
		async fetchBrands({commit}) {
			commit("setLoading", {dataName: "brands", status: true});
			let token = localStorage.getItem("token");
			try {
				let {data} = await axios.get(process.env.VUE_APP_API_URL + "/api/all-brands", {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				});
				// console.log("Brands : ", data);
				commit("setBrands", data);
				commit("setLoading", {dataName: "brands", status: false});
			} catch (error) {
				console.log("Brands : ", error);
				commit("setLoading", {dataName: "brands", status: false});
				// commit("setProducts", []);
				// useToast().error('Error While Fetching New Arrivals Products Products', {timeout : 3000})
			}
		},
	},
	mutations: {
		setProducts: (state, {type, payload}) => {
			if (payload && payload.data) {
				state.products[type].data = payload.data; // this is temp, in some api's we are getting response with pagination. so we need to handle.
				state.products[type].last_page = payload.last_page;
				state.products[type].total = payload.total;
				state.products[type].per_page = payload.per_page;
			}
		},
		setFeaturedProducts: (state, payload) => {
			state.featuredProducts = payload;
		},
		setHomePageProducts : (state, payload) => {
			state.products.home_page_products.data = payload;
		},
		updateProducts: (state, {type, payload}) => {
			// let products = [...state.products, ...payload];
			state.products[type].data = [...state.products[type].data, ...payload.data];
			// state.products = products;
		},
		setBrands: (state, payload) => {
			state.brands = payload;
		},
		setSelectedProduct: (state, payload) => {
			state.selectedProduct = payload;
		},
		setLoading: (state, {dataName, status}) => {
			state.status[dataName].loading = status;
		},
		setError: (state, {dataName, error}) => {
			state.status[dataName].error = error;
		},
	},
};
